// src/pages/IssueReporting/components/PageHeader.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const PageHeader = () => {
    return (
        <Box sx={{mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div>
                <Typography variant="h5" sx={{fontWeight: 600, mb: 1}}>
                    My Support Tickets
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    View and manage all your support requests
                </Typography>
            </div>

            <Button
                variant="contained"
                sx={{
                    borderRadius: '8px',
                    backgroundColor: '#398DD2',
                    textTransform: 'none',
                    boxShadow: 'none',
                    '&:hover': {
                        backgroundColor: '#2b78be',
                        boxShadow: 'none'
                    }
                }}
                href="/tickets/new"
            >
                Report New Issue
            </Button>
        </Box>
    );
};

export default PageHeader;